import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import commonFunction from '@/utils/CommonFunction'
Vue.prototype.$CF = commonFunction

export const EventBus = new Vue();
import VxeUIBase from 'vxe-pc-ui'
import 'vxe-pc-ui/es/style.css'

import VxeUITable from 'vxe-table'
import 'vxe-table/es/style.css'
// ...

Vue.use(VxeUIBase)
Vue.use(VxeUITable)

//use component
import Vant from "vant";
Vue.use(Vant);
import { Lazyload } from 'vant';
Vue.use(Lazyload);
// 注册时可以配置额外的选项
Vue.use(Lazyload, {
  lazyComponent: true,
});
import ElementUI from 'element-ui';
Vue.use(ElementUI);
import moment from 'moment'
import 'moment/locale/zh-cn';
Vue.prototype.$moment = moment;
import '@vant/touch-emulator';
import "@/assets/iconfont/symbol/iconfont.css";
import "@/assets/iconfont/symbol/iconfont";
Vue.filter('dateformat',function (input,formatString) {//当input为时间戳时，需转为Number类型
// 使用momentjs这个日期格式化类库实现日期的格式化功能
  return moment(input).local('zh-cn').format(formatString);
});
import LongPress from "@/utils/directives/longpress";
Vue.directive('longpress', LongPress);


//import css
import "@/css/global.scss"
import 'vant/lib/index.css';
import 'element-ui/lib/theme-chalk/index.css';


import axios from 'axios'

import request from "@/api/request";
import utils from "@/api/utils";
Vue.prototype.$request = {
  basic: request,
  utils:utils
};


// 将axios挂载到Vue原型上
Vue.prototype.$http = axios


/* 使用ES6模块引入 */
import wx from 'weixin-js-sdk';
// wx.config({
//   debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//   appId: '', // 必填，公众号的唯一标识
//   timestamp: Date.now(), // 必填，生成签名的时间戳
//   nonceStr: '', // 必填，生成签名的随机串
//   signature: '',// 必填，签名
//   jsApiList: [] // 必填，需要使用的JS接口列表
// });


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
// app.vue写在script里面  main.js写在app挂载完之后
const debounce = (fn, delay) => {
  let timer
  return (...args) => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
  constructor(callback) {
    callback = debounce(callback, 200);
    super(callback);
  }
}
